import { neutral8 } from '../../colors';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    color: neutral8,
    marginTop: 5.5,
    fontSize: idsTokens.typography.font.size.sm,
    lineHeight: idsTokens.typography.lineHeight.sm,
    fontWeight: idsTokens.typography.font.weight.regular,
    letterSpacing: idsTokens.typography.spacing.letter.md,
    '&.Mui-disabled': {
      color: neutral8,
    },
  },
  sizeSmall: {
    marginTop: 4,
  },
});
